export const mergeHits = (resultsArray) => {
  return resultsArray.reduce((mergedHits, currentResult) => {
    if (currentResult?.hits) {
      mergedHits.push(...currentResult.hits)
    }
    return mergedHits
  }, [])
}

export const mergeFacets = (facetsArray) => {
  const mergedFacets = {}
  facetsArray.forEach((facets) => {
    if (facets) {
      Object.keys(facets).forEach((facetKey) => {
        if (!mergedFacets[facetKey]) {
          mergedFacets[facetKey] = { ...facets[facetKey] }
        } else {
          Object.keys(facets[facetKey]).forEach((facetValue) => {
            if (mergedFacets[facetKey][facetValue]) {
              mergedFacets[facetKey][facetValue] += facets[facetKey][facetValue]
            } else {
              mergedFacets[facetKey][facetValue] = facets[facetKey][facetValue]
            }
          })
        }
      })
    }
  })

  return Object.keys(mergedFacets).map((facetKey) => ({
    field_name: facetKey,
    counts: Object.keys(mergedFacets[facetKey]).map((facetValue) => ({
      count: mergedFacets[facetKey][facetValue],
      value: facetValue,
      label: facetValue,
    })),
  }))
}

export const transformFacets = (facets) => {
  return Object.entries(facets).map(([key, values]) =>
    values.map((value) => `${key}:${value}`),
  )
}

export const parseQueryFacets = (queryString) => {
  const arr = Array.isArray(queryString) ? queryString : [queryString]
  return arr.map((item) => item.split(',').map((filter) => filter.trim()))
}

export const parseQueryFilters = (queryString) => {
  const result = {}
  const arr = Array.isArray(queryString) ? queryString : [queryString]

  arr.forEach((item) => {
    item.split(',').forEach((pair) => {
      const [key, value] = pair.split(':').map((str) => str.trim())

      if (result[key]) {
        result[key].push(value)
      } else {
        result[key] = [value]
      }
    })
  })

  return result
}

export const markDisabled = (array1 = [], array2 = []) => {
  const findInArray2 = (fieldName, value) => {
    const entry = array2.find((item) => item.field_name === fieldName)
    if (entry && entry.counts.length > 0) {
      return entry.counts.find((count) => count.value === value)
    }
    return null
  }
  const newArray = array1.map((item1) => {
    const newCounts = item1.counts.map((countItem1) => {
      const matchInArray2 = findInArray2(item1.field_name, countItem1.value)

      if (matchInArray2) {
        return { ...countItem1, count: matchInArray2.count }
      } else {
        return { ...countItem1, disabled: true }
      }
    })

    return { ...item1, counts: newCounts }
  })

  return newArray
}
